import { render, staticRenderFns } from "./ApplicationTypeTable.vue?vue&type=template&id=cb2ac02c"
import script from "./ApplicationTypeTable.vue?vue&type=script&lang=ts"
export * from "./ApplicationTypeTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports